import {
    Clock,
    Zap,
    Users,
    MapPin,
    Tag,
    ShieldCheck,
} from "lucide-react";
import { BENEFITS } from "../../lib/constants";

const ICONS = {
    clock: Clock,
    zap: Zap,
    users: Users,
    "map-pin": MapPin,
    tag: Tag,
    "shield-check": ShieldCheck,
};

export const BenefitsBanner = () => {
    return (
        <section
            id="beneficios"
            data-testid="benefits-section"
            className="bg-[#0a0a0a] text-white py-16 md:py-24 noise-bg relative"
        >
            <div className="container mx-auto px-4 md:px-8 relative z-10">
                <div className="max-w-3xl mb-12">
                    <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                        · Por que somos referência ·
                    </span>
                    <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black uppercase tracking-tight mt-3">
                        Vantagens que fazem diferença na hora da{" "}
                        <span className="text-[#f45100]">emergência</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                    {BENEFITS.map((b, i) => {
                        const Icon = ICONS[b.icon];
                        return (
                            <div
                                key={i}
                                data-testid={`benefit-card-${i}`}
                                className="group p-6 md:p-8 bg-white/[0.03] border border-white/10 hover:border-[#f45100] hover:bg-white/[0.06] transition-all duration-300"
                            >
                                <div className="flex items-start gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-[#f45100] flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                                        <Icon size={22} strokeWidth={2.5} />
                                    </div>
                                    <div>
                                        <h3 className="font-display text-xl font-extrabold uppercase tracking-tight">
                                            {b.title}
                                        </h3>
                                        <p className="mt-2 text-white/70 text-sm leading-relaxed">
                                            {b.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
